import { render, staticRenderFns } from "./BranchForm.vue?vue&type=template&id=5677cf1b&"
import script from "./BranchForm.vue?vue&type=script&lang=js&"
export * from "./BranchForm.vue?vue&type=script&lang=js&"
import style0 from "./BranchForm.vue?vue&type=style&index=0&id=5677cf1b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports